/***
 * Configuration for Clients Area Routes
 *
 * Clients Area Routes
 ***/

/* ----- Views ----- */

import ClientsAreaDashboard from "@/pages/ClientsArea/ClientsAreaDashboard";
import ClientsAreaProfile from "@/pages/ClientsArea/Profile/ClientsAreaProfile";
import ClientsAreaDocuments from "@/pages/ClientsArea/Documents/ClientsAreaDocuments";
import ClientsAreaServices from "@/pages/ClientsArea/Services/ClientsAreaServices";
import ClientsAreaInterventions from "@/pages/ClientsArea/Interventions/ClientsAreaInterventions";
import ClientsAreaTrends from "@/pages/ClientsArea/Trending/ClientsAreaTrends";
import ClientsAreaAudits from "@/pages/ClientsArea/Audits/ClientsAreaAudits";

/* ----- ----- ----- ----- ----- ----- ----- */

const clientsAreaRoutes = [
    {
        path: 'dashboard',
        name: 'caDashboard',
        component: ClientsAreaDashboard,
        meta: {},
    },
    {
        path: 'profile',
        name: 'caProfile',
        component: ClientsAreaProfile,
        meta: {},
    },
    {
        path: 'documents',
        name: 'caDocuments',
        component: ClientsAreaDocuments,
        meta: {},
    },
    {
        path: 'services',
        name: 'caServices',
        component: ClientsAreaServices,
        meta: {},
    },
    {
        path: 'interventions',
        name: 'caInterventions',
        component: ClientsAreaInterventions,
        meta: {},
    },
    {
        path: 'trends',
        name: 'caTrends',
        component: ClientsAreaTrends,
        meta: {},
    },
    {
        path: 'audits',
        name: 'caAudits',
        component: ClientsAreaAudits,
        meta: {},
    },
]
export default clientsAreaRoutes